import { deletePricingHolidayRequest } from "../../data/pricingHolidayApi";

export async function deletePricingHolidayUseCase(id) {
  if (!id) {
    throw new Error("El id es obligatorio.");
  }

  return await deletePricingHolidayRequest(id);
}
